export const reset_password = {
  field: {
    email: 'Alamat e-mail',
    password: 'Password',
    confirm_password: 'Password Konfirmasi',
    code: 'Kode verifikasi dari email'
  },
  button: { send_code: 'Kirim kode setel ulang kata sandi', reset: 'Setel ulang kata sandi' },
  link: {
    to_auth_page: 'Kembali',
    success_change_link_to_auth_page: 'log in',
    send_repeated: 'Kirim kode lagi'
  },
  success_change_password: 'Kata sandi berhasil diubah, sekarang Anda bisa',
  error: {
    wrong_email: 'Salah e-mail',
    wait_attempts_time_interval: 'Silakan coba lagi dalam 30 detik',
    wrong_password: 'Kata sandi tidak memenuhi persyaratan',
    email_code_not_found_or_has_expired: 'Kode salah',
    not_valid_password: 'Kata sandi Anda tidak valid',
    code_size: 'Kode harus 6 karakter',
    invalid_format: "Bidang kata sandi baru dalam format yang salah"
  },
  password_email_not_received: 'Tidak menerima kode email?',
  success_send_code:
    'Email dengan kode telah dikirimkan ke {email} Anda, harap masukkan di kolom di bawah ini untuk melanjutkan',
  generate_password: 'Hasilkan kata sandi',
  password_requirements: 'Persyaratan kata sandi',
  six_symbols: '6 karakter',
  one_number: '1 digit',
  one_uppercase_letter: '1 huruf kapital',
  one_lowercase_letter: '1 huruf besar',
  one_special_character: '1 karakter khusus (!@#;%^&* dll)',
  password_spaces: 'Kata sandi tanpa spasi',
  matched_passwords: 'Password cocok',
  change_by: {
    email: 'Mengedit melalui email',
    password: 'Ubah melalui kata sandi saat ini'
  },
  day_block: "Batas upaya harian telah kedaluwarsa, gunakan kode terakhir yang dikirim atau minta yang baru besok",
  code_exist: 'Gunakan kode terakhir yang dikirim atau minta yang baru',
  send_email_to_confirm: 'Email dengan kode akan dikirimkan ke {email} Anda.',
  send: 'Kirim'
};
